




import Vue from "vue";
import PersonnelChangeUpload from "@/components/personnel-change/personnel-change-upload.component.vue";
export default Vue.extend({
  components: {
    "personnel-change-upload": PersonnelChangeUpload,
  },
});
